/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-console */
import React from "react"
import PropTypes from "prop-types"
// Material Ui
import Checkbox from "@material-ui/core/Checkbox"
import FormControlLabel from "@material-ui/core/FormControlLabel"

const proptypes = {
  input: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  name: PropTypes.string,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  meta: PropTypes.object.isRequired,
  readonly: PropTypes.bool
}

const defaultprops = {
  name: undefined,
  placeholder: undefined,
  readonly: false
}

const CheckBoxInput = ({
  input,
  //  type,
  //  name,
  label
  //  placeholder,
  //  readonly,
  //  meta: { touched, error, warning },
}) => (
  <FormControlLabel
    control={<Checkbox checked={input.value} value="checkedA" {...input} />}
    label={label}
  />
)

CheckBoxInput.propTypes = proptypes
CheckBoxInput.defaultProps = defaultprops

export default CheckBoxInput
